import { FormlySelectOption } from '@ngx-formly/core/select';

export const generateRangeNumber = (start: number, end: number) => Array.from(Array(end - start + 1).keys()).map(x => x + start);

export function getOptionSelect(arr: any[]): FormlySelectOption[] {
  return arr.map(v => ({ label: v, value: v, disable: false }));
}
